module.exports = __webpack_public_path__ + "static/media/seamstress-qualified.71052893.jpg";